// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ar-style .rules-icon{transform:rotateY(0deg)!important}.ar-style .policy-flag{margin-right:.42667rem;margin-left:0!important;border-radius:0 .32rem .32rem 0!important}", ""]);
// Exports
module.exports = exports;
